import { jwtDecode } from 'jwt-decode';

/** Admin dashboard JWTs include `role`; customer app-user JWTs do not. */
export function isAdminDashboardToken(token) {
    if (!token) return false;

    try {
        const decoded = jwtDecode(token);
        return Boolean(decoded?.role);
    } catch {
        return false;
    }
}
